import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconArrowUpGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <>
      <g clipPath="url(#clip0_102_35983)" {...(props.group ?? {})}>
        <path
          d="M13.7765 8.39206L12.8365 7.45206L9.10986 11.1721V3.05873H7.77653V11.1721L4.05653 7.44539L3.10986 8.39206L8.4432 13.7254L13.7765 8.39206Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_102_35983">
          <rect
            width="16"
            height="16"
            fill={fillColor}
            transform="translate(0.443359 0.392059)"
          />
        </clipPath>
      </defs>
    </>
  );
};

export const IconArrowUpSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      transform="scale(-1 -1)"
      {...(props.svg ?? {})}
    >
      <IconArrowUpGroup {...props} />
    </svg>
  );
};
